
import axios from "axios";
import { getProtocolAndDomain } from "./axiosClient";


export const gotdapi = {
    sendMessage: async (peer:string,message: string): Promise<boolean> => {
        // const payload = { "kind": "request", "channel": "telegram", "action": "send_message", "data": { "chat_id": 5090230676, "text": message, "peer": "5090230676" } }
        const payload = {
            "session_id": 'do not need',
            "text": message,
            "peer": peer
        }
        let token = localStorage["access_token"]; // thay bằng token thực tế nếu có
        //token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFkbWluIiwicm9sZSI6ImFkbWluX2x2MCIsImV4cCI6MTc2NDkyODQzN30.J2taO6FUFP1Zvkb8LmrjhP4Cq6hV5QLHTfHXuMqXqhM"
        let result = false;
        const protocolAndDomain = getProtocolAndDomain(); // Lấy protocol và domain hiện tại
        await axios.post(`${protocolAndDomain}/prodgotd/send_message`, payload, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `${token}`,  // 👈 thêm header tại đây
            },
            timeout: 10000,
        })
            .then(response => {
                console.log("✅ Gửi thành công:", response.data);
                result = true
            })
            .catch(error => {
                console.error("❌ Gửi lỗi:", error);
            });
        return result
    }

}